import { observable, action, runInAction } from "mobx";
import * as API from "../../../api/m/invite";
import { InviteInfo } from "./type";
import { MDialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";
import { mobileReg, mobileLocalReg, regexEmail } from "../../../utils/index"

const { toast } = MDialog;

class MInviteStore {

    @observable inviteInfos: any[] = []

    @action
    init = () => {
        this.inviteInfos.push({
            inviteNo: 1,
            invitee: '',
            contact: ''
        })
    };
    @action
    addInvite = () => {
        this.inviteInfos.push({
            invitee: '',
            contact: ''
        })
    };

    @action
    deleteInvite = (index: any) => {
        this.inviteInfos.splice(index, 1);
    };

    @action
    changeName = (value: any, index: any) => {
        for (let i = 0; i < this.inviteInfos.length; i++) {
            if (i == index) {
                this.inviteInfos[i].invitee = value;
            }
        }
    }
    @action
    changeAreacode = (value: any, index: any) => {
        for (let i = 0; i < this.inviteInfos.length; i++) {
            if (i == index) {
                this.inviteInfos[i].areaCode = value;
            }
        }
    }

    @action
    changeContact = (value: any, index: any) => {
        for (let i = 0; i < this.inviteInfos.length; i++) {
            if (i == index) {
                this.inviteInfos[i].contact = value;
            }
        }
    }

    @action
    checkInfos = (type?: string) => {
        for (let i = 0; i < this.inviteInfos.length; i++) {
            if (!this.checkInviteParams(this.inviteInfos[i].contact, this.inviteInfos[i].invitee, this.inviteInfos[i].areaCode, type)) {
                return false;
            }
        }
        return true;
    }

    @action
    checkInviteParams = (contact: any, invitee: any, areaCode?: string, type?: string) => {
        if (contact == undefined || invitee == undefined || invitee.trim() == '' || contact.trim() == '') {
            toast({
                type: 'info',
                content: getLabel('61249', '请输入必填项!'),
            });
            return false;
        }
        let nameReg = /^([\u2e80-\u9fff a-zA-Z]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/;
        if (invitee.trim().length > 50) {
            toast({
                type: 'info',
                content: getLabel('61252', '姓名必须是中英文字符,且长度在1到50个字节之间!'),
            });
            return false;
        }
        if (!nameReg.test(invitee)) {
            toast({
                type: 'info',
                content: getLabel('61252', '姓名必须是中英文字符,且长度在1到50个字节之间!'),
            });
            return false;
        }
        let emailReg = regexEmail;
        if (type === 'mail') {
            if (!emailReg.test(contact)) {
                toast({
                    type: 'info',
                    content: getLabel('157593', '请输入有效的邮箱'),
                });
                return false;
            }
        } else {
            if (areaCode === '+86') {//国内电话号校验
                let phoneReg = mobileLocalReg
                if (!phoneReg.test(contact)) {
                    toast({
                        type: 'info',
                        content: getLabel('179710', '请输入有效手机号码'),
                    });
                    return
                }
            } else {//国外电话号校验
                let phoneReg = mobileReg
                if (!phoneReg.test(contact)) {
                    toast({
                        type: 'info',
                        content: getLabel('179710', '请输入有效手机号码'),
                    });
                    return
                }
            }
        }
        return true;

    }

    @action
    saveInviteInfos = (type?: string) => {
        if (!this.checkInfos(type)) {
            return
        }
        let data = {
            inviteInfos: this.inviteInfos.map(it => {
                const info = { ...it };
                if (info.areaCode) {
                    info.contact = info.areaCode + info.contact;
                }
                return info;
            })
        };
        API.saveAppInvitees(data).then((result: any) => {
            runInAction(() => {
                if (result) {
                    console.log(result);
                    if (result.inviteInfos && result.inviteInfos.length > 0) {
                        let info = '';
                        result.inviteInfos.map((invite: any) => {
                            info = `${info}
                            ${invite.contact + invite.message}`
                        })
                        toast({
                            type: 'info',
                            content: info,
                        });
                        // this.inviteInfos = [];
                        // this.init();
                    }
                }
            });
        })
            .catch((error) => {
                console.log(error);
            });
    }
}

const instance = new MInviteStore();

export default instance;
